<template>
  <div>
    <el-row class="grid-table">
      <el-table stripe border style="width:100%;margin-top:10px" :data="table_data.data">
        <el-table-column prop="exam.examTitle" label="试卷标题"></el-table-column>
        <el-table-column prop="judgeUser.nickname" label="评卷卷人"></el-table-column>
        <el-table-column prop="totalScores" label="得分"></el-table-column>
        <el-table-column prop="startTime" label="开始答题时间" :formatter="tableFormatter('dateFormat','startTime','yyyy-MM-dd hh:mm')"></el-table-column>
        <el-table-column prop="endTime" label="完成答题时间" :formatter="tableFormatter('dateFormat','endTime','yyyy-MM-dd hh:mm')"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="goDetail(scope.row.objectId,scope.row.user.objectId)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-size="search_data.pageSize"
        layout="total, prev, pager, next,jumper"
        :total="table_data.total">
      </el-pagination>
    </el-row>
  </div>
</template>
<script type="text/javascript">
import utils from '@/utils/index'
import { tableFormatter,strategyMap } from "@/utils/formatter.js";
import common from '@/../server/common'
import '@/components/index'

export default {
  name: 'list',
  data () {
    return {
      tableFormatter,
      strategyMap,
      page_grade: common.page_grade,
      search_data: {
        page: 1,
        pageSize: 10
      },
      table_data: {
        total: 0,
        data: []
      },
      loading: false,
    }
  },
  methods: {
    goDetail(id,userId){
      this.$router.push('/exam/recordDetail?recordId='+id+'&userId='+userId);
    },
    // ajax请求列表数据
    ajaxData () {
      utils.ajax.call(this, '/recordList', this.search_data, (obj, err) => {
        if (!err) {
          this.table_data.data = obj.list
          this.table_data.total = obj.total
          this.search_data.page = obj.page
        }
      })
    },
    // 点击查询
    onSearch () {
      this.search_data.page = 1
      this.ajaxData()
    },
    handleCurrentChange (page) {
      if (page !== this.search_data.page) {
        this.search_data.page = page
        this.ajaxData()
      }
    }
  },
  mounted () {
    this.ajaxData()
  },
  mixins: [common.mixin]
}
</script>
<style lang="less">
  .grid-table {
    .el-form-item {
      display: inline-block;
      max-height: 240px;
      width: ~'calc(24% - 10px)';
      &:first-child {
        .el-input {
          margin-right: 25px;
        }
      }
      &:last-child {
        overflow: hidden;
        white-space: nowrap;
        vertical-align: bottom;
      }
    }
    .el-pagination {
      margin-top: 5px;
      text-align: right;
    }
    .el-cascader--small .el-cascader__label {
      line-height: 40px;
    }
  }
</style>
